import { ContentHeader } from 'mfa'
import { OK } from '../../constants/ui.labels'
import Button from '@talkdesk/cobalt-react-button'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'

const WarningMessage = ({ onClick, title, message, actionMessage = OK }) => {
  return (
    <Flex direction='column' alignX='center'>
      <Flex direction='column' alignX='center' padding='4' gap='2'>
        <IconWithProvider name='error_circle_outline' size='large' />
        <ContentHeader title={title} message={message} />
        <Flex gap='2' paddingTop='4'>
          <Button htmlType='button' onClick={onClick}>
            {actionMessage}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default WarningMessage
